import {
  Upload,
  RefreshCw,
  Cog,
  PenSquare,
  ListMusic,
  Radio,
} from "lucide-react";
import type { LogCategory, LogStatus } from "./logDerivation";

export const CATEGORY_ICON: Record<LogCategory, typeof Upload> = {
  upload: Upload,
  reupload: RefreshCw,
  processing: Cog,
  metadata: PenSquare,
  playlist: ListMusic,
  publish: Radio,
  update: PenSquare,
};

export const STATUS_BADGE: Record<
  LogStatus,
  { label: string; className: string }
> = {
  success: { label: "Success", className: "bg-light text-secondary" },
  error: { label: "Error", className: "bg-danger-subtle text-danger" },
  info: { label: "Info", className: "bg-primary-subtle text-primary" },
};

const DAY_MINS = 1440;

export const DATE_OPTIONS = [
  { id: "all_time", label: "All Time", mins: 0 },
  { id: "7d", label: "Last 7 days", mins: 7 * DAY_MINS },
  { id: "15d", label: "Last 15 days", mins: 15 * DAY_MINS },
  { id: "30d", label: "Last 30 days", mins: 30 * DAY_MINS },
] as const;

export const LOGS_PER_PAGE = 50;

export const formatRelative = (mt: number): string => {
  if (!mt) return "--";
  const d = new Date(mt);
  const sameDay = d.toDateString() === new Date().toDateString();
  const time = d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  return sameDay ? `Today at ${time}` : `${d.toLocaleDateString()} · ${time}`;
};

export const formatAbsolute = (mt: number): string =>
  mt ? new Date(mt).toLocaleString() : "";

export const initialsOf = (name?: string): string => {
  if (!name) return "";
  const words = name.trim().split(/\s+/).filter(Boolean);
  return words.length >= 2
    ? (words[0][0] + words[1][0]).toUpperCase()
    : name.slice(0, 2).toUpperCase();
};

export const isImageUrl = (value: string): boolean =>
  typeof value === "string" &&
  /^https?:\/\//i.test(value) &&
  /(\.(jpe?g|png|webp|gif)|\.cms)(\?.*)?$/i.test(value);
